export default "__VITE_ASSET__6ae3063b__"